import TopScanProductsPanel from "./topScanProductsPanel.container";

export default TopScanProductsPanel;
